import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import LanguageContext from 'context/LanguageContext';

import Spinner from 'components/Spinner/Spinner';
import ProjectSection from 'components/ProjectSection/ProjectSection';

export default function Progetti() {
  const { language } = useContext(LanguageContext);
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState();

  async function getProjects() {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}projects?per_page=100`
      );
      setProjects(response.data);
      setIsLoading(false);
      console.log(projects);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
    getProjects();
  }, []);
  return (
    <div className="h-full bg-gray-800 ">
      <div className="container mx-auto">
        {language === 'it' && (
          <>
            <p className="px-10 pt-10 mb-10 text-4xl font-bold text-white">
              I NOSTRI PROGETTI
            </p>
            {isLoading && (
              <div className="flex items-center justify-center">
                <Spinner className="w-16 h-16 text-white" />
              </div>
            )}
            {!isLoading &&
              projects &&
              projects
                .sort((a, b) => a.acf.id - b.acf.id)
                .map((item, id) => (
                  <ProjectSection
                    project={item.acf}
                    id={id}
                    language={language}
                  />
                ))}
          </>
        )}
        {language === 'en' && (
          <>
            <p className="px-10 pt-10 mb-10 text-4xl font-bold text-white">
              OUR PROJECTS
            </p>
            {isLoading && (
              <div className="flex items-center justify-center">
                <Spinner className="w-16 h-16 text-white" />
              </div>
            )}
            {!isLoading &&
              projects &&
              projects
                .sort((a, b) => a.acf.id - b.acf.id)
                .map((item, id) => (
                  <ProjectSection
                    project={item.acf}
                    id={id}
                    language={language}
                  />
                ))}
          </>
        )}
      </div>
    </div>
  );
}
